module.exports = __webpack_public_path__ + "img/xls.fc83e4e8.svg";